import Auth from '../../modules/Authentication'
import {handleErrors, handleResponse} from '../../modules/Utils'
import {apiUrl} from '../../variables/index'

const headers = {}

export default class Claims {
  auth = new Auth()
  list = ({claimant, status}) => {
    const select = '*'
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(
      `${apiUrl}claims?select=${select}` +
        (claimant ? `&claimant=${claimant || ''}` : '') +
        (status ? `&status=${status || ''}` : ''),
      {
        headers: headers,
        method: 'GET',
      },
    )
      .then(handleErrors)
      .then(handleResponse)
  }
  listByManager = ({claimant, status}) => {
    const select = '*'
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(
      `${apiUrl}claims/manager?select=${select}` +
        (claimant ? `&claimant=${claimant || ''}` : '') +
        (status ? `&status=${status || ''}` : ''),
      {
        headers: headers,
        method: 'GET',
      },
    )
      .then(handleErrors)
      .then(handleResponse)
  }
  get = key => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}claims/${key}`, {
      headers: headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  create = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}claims/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  update = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}claims/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }

  operation = (key, data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}claims/${key}`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }

  remove = (data, claimant) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(
      `${apiUrl}claims/` + (claimant ? `?claimant=${claimant || ''}` : ''),
      {
        headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      },
    ).then(handleErrors)
  }
}
